<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        技能者 - 新規登録
        <div class="headerBtn" @click="screenTransition()" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{ errorMessage }}
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              CCUS登録情報
            </div>
            <div class="inputTitle" style="display: flex; color: red;">
              CCUSの技能者IDをお持ちでしたら、ご入力下さい。
            </div>
            <div class="inputTitle" style="display: flex;">
              CCUS技能者ID
            </div>
            <div class="row">
              <validation-provider name="CCUS技能者ID" rules="digits:14" vid="ccusWorkerId" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" pattern="" v-model="detail.ccusWorkerId"
                    placeholder="CCUS登録時に発行される14桁の技能者ID">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              CCUS技能者本人確認番号
            </div>
            <div class="row">
              <validation-provider name="技能者本人確認番号" rules="digits:4|required_if:ccusWorkerId" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.ccusSecurityCode" placeholder="技能者カード裏面記載の4桁の本人確認番号">
                  <div class="errMsg" v-if="ProviderProps.errors[0]" style="width:150%">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              生年月日
            </div>
            <div class="row">
              <validation-provider name="生年月日" rules="birthDay|required_if:ccusWorkerId" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="Date" max='9999-12-31' class="text large" v-model="detail.birthdate">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              氏名
            </div>
            <div class="row">
              <p class="inputTitle editable">姓</p>
              <validation-provider name="姓" rules="required|max:32|valid_characters" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.lastName" placeholder="例：田中">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">名</p>
              <validation-provider name="名" rules="required|max:32|valid_characters" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.firstName" placeholder="例：太郎">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">フリガナ（姓）</p>
              <validation-provider name="フリガナ（姓）" rules="required|max:32|furigana" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.lastNameKana" placeholder="例：タナカ">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">フリガナ（名）</p>
              <validation-provider name="フリガナ（名）" rules="required|max:32|furigana" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.firstNameKana" placeholder="例：タロウ">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              基本情報
            </div>
            <div class="row">
              <p class="inputTitle editable">性別</p>
              <validation-provider name="性別" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="genderProps">
                  <div class="selectdiv">
                    <select v-model="detail.gender">
                      <option value="" selected>未選択</option>
                      <option v-for="gender in optionGender" v-bind:value="gender.id" v-bind:key="gender.id">
                        {{ gender.name }}
                      </option>
                    </select>
                  </div>
                  <div class="errMsg" v-if="genderProps.errors[0]">
                    <span class="errSpan">
                      {{ genderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">国籍</p>
              <validation-provider name="国籍" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="nationalityProps">
                  <div class="selectdiv">
                    <select v-model="detail.nationality">
                      <option value="" selected>未選択</option>
                      <option v-for="nationality in optionNationality" v-bind:value="nationality.id"
                        v-bind:key="nationality.id">
                        {{ nationality.name }}
                      </option>
                    </select>
                  </div>
                  <div class="errMsg" v-if="nationalityProps.errors[0]">
                    <span class="errSpan">
                      {{ nationalityProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">電話番号</p>
              <validation-provider name="電話番号" rules="min:10|max:14|numeric" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.tel" placeholder="例：0312345678 ハイフン無し半角数字のみ入力">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">ログインID</p>
              <validation-provider name="ログインID" rules="required|min:4|max:96|loginId" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.loginId" placeholder="例：Xxxx.xxx" readonly>
                  <div v-if="idCheckFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
                    <div　class="errMsg">
                      <div class="errDiv">
                        既に登録されているログインIDです.</br>
                        新しく取得したログインIDで再度ご登録をお願い致します．
                      </div>
                    </div>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">メールアドレス</p>
              <validation-provider name="メールアドレス" rules="emailVaridate|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.email" placeholder="例：xxxxxx@xxx.xxx">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">パスワード</p>
              <validation-provider name="パスワード" rules="required|min:8|max:64|password" vid="confirmation" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.password" placeholder="">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">パスワード確認</p>
              <validation-provider name="パスワード確認" rules="required|confirmed:confirmation|min:8|max:64|password"
                mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.confirm" placeholder="">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              住所
            </div>
            <div class="row">
              <p class="inputTitle editable">郵便番号</p>
              <validation-provider name="郵便番号" rules="digits:7|addressFlg" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" @change="getAddress()" class="text large" name="postalCode"
                    v-model="detail.postalCode" placeholder="例：1000001 ハイフン無し半角数字のみ入力" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan" v-if="postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                    <span class="prefectureErrSpan" v-if="!postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">都道府県</p>
              <div class="rowRight">
                <validation-provider name="都道府県" rules="max:255" mode="lazy">
                    <div class="rowRight" slot-scope="ProviderProps">
                      <input type="text" class="text large" :placeholder="'例：東京都'" name="prefecture"
                      v-model="detail.prefecture">
                        <div class="errMsg" v-if="ProviderProps.errors[0]">
                          <span class="errSpan">
                            {{ ProviderProps.errors[0] }}
                          </span>
                        </div>
                    </div>
                </validation-provider>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">市区町村</p>
              <validation-provider name="町・番地" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <div class="rowRight">
                    <input type="text" class="text large" :placeholder="'例：千代田区'" name="city" v-model="detail.city" />
                    <div class="errMsg" v-if="ProviderProps.errors[0]">
                      <span class="errSpan">
                        {{ ProviderProps.errors[0] }}
                      </span>
                    </div>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">町・番地</p>
              <validation-provider name="町・番地" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" :placeholder="'例：丸の内1-1'" name="town" v-model="detail.town" placeholder="例：丸の内1-1" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">建物名/部屋番号</p>
              <validation-provider name="建物名/部屋番号" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" :placeholder="'例：千代田ビル2F'" name="otherAddress" v-model="detail.otherAddress"
                    placeholder="例：千代田ビル2F" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <!-- ローディング -->
          <div v-if="postLodingFlg">
            <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
            </vue-loading>
            <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
          </div>
          <!-- 登録エラー表示 -->
          <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
            <div　class="errMsg">
              <div class="errDiv">
                データの登録中に問題が発生しました。
              </div>
            </div>
          </div>
          <!-- 入力チェックエラー表示 -->
          <div v-if="validationErrMsg.length > 0">
            <div　class="errMsg" v-for="error in validationErrMsg">
              <div class="errSpan">{{ error }}</div>
            </div>
          </div>
          <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm(detail, ccus)" 
              v-bind:class="{ disabled: isProcessing() || !ObserverProps.validate 
              ||!isPostDisabled(ObserverProps,postalHasError)
              || detail.loginId === ''
              || detail.lastName === ''
              || detail.firstName === ''
              || detail.lastNameKana === ''
              || detail.firstNameKana === ''
              || detail.password ===''
              || detail.confirm ===''
              || detail.nationality ===''
              || detail.gender ==='', 
              active: isPostDisabled(ObserverProps,postalHasError)
              && detail.loginId !== ''
              && detail.lastName!== ''
              && detail.firstName!== ''
              && detail.lastNameKana!== ''
              && detail.firstNameKana!== ''
              && detail.password !==''
              && detail.confirm !==''
              && detail.nationality !==''
              && detail.gender !==''
              && ObserverProps.validate  }"
              :disabled="!isPostDisabled(ObserverProps,postalHasError)
              || detail.loginId === ''
              || detail.lastName === ''
              || detail.firstName === ''
              || detail.lastNameKana === ''
              || detail.firstNameKana === ''
              || detail.password ===''
              || detail.confirm ===''
              || detail.nationality ===''
              || detail.gender ===''">登録
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import common from '../services/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
// import common from '../services/common';

export default {
  title: '技能者登録',
  name: 'WorkerAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      companyId: '', // ログイン事業者ID
      num: '',
      idCheckFlg: false,
      // 登録用モデル
      detail: {
        // CCUS登録情報
        ccusWorkerId: '',
        ccusSecurityCode: '',
        birthdate: '',
        // ログインID【必須】
        loginId: '',
        // 氏名【必須】
        workerName: '',
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        // 基本情報【任意】
        gender: '',
        tel: '',
        email: '',
        nationality: '',
        // 住所【任意】
        postalCode: '',
        prefecture: '',
        city: '',
        town: '',
        otherAddress: '',
        password: '',
        confirm: '',
      },
      ccus: {
        version: null,
        ccusId: null,
        value: null,
        modified: null,
      },
      // ドロップダウンリスト
      // 選択用性別配列
      // TODO 性別IDリスト取得API要作成？
      optionGender: [
        {
          id: 'ge3138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: '男性',
        },
        {
          id: 'ge2138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: '女性',
        },
        {
          id: 'ge1138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: 'その他',
        },
      ],
      // 国籍（日本：１　海外：２）
      optionNationality: [
        {
          id: 1,
          name: '日本',
        },
        {
          id: 2,
          name: '海外',
        },
      ],
      // ローディング
      getLodingFlg: false,     // データ取得時ローディング用フラグ
      getErrorFlg: false,      // データ取得時エラーフラグ
      postLodingFlg: false,    // データ登録時ローディングフラグ
      postErrorFlg: false,     // データ登録時エラーフラグ
      // 入力チェック
      validationErrFlg: false, // 入力チェックエラーフラグ
      processing: false,
      validationErrMsg: [],    // 入力チェックエラーメッセージ用配列
      errorMessage: '',
      // 郵便番号エラー判定用フラグ
      postalHasError:true,
    };
  },
  // 初期処理
  async mounted() {
    // セッション情報からログイン事業者IDを取得
    this.companyId = this.$store.getters.session.companyId;
    this.branchId = this.$store.getters.session.branchId ?? "";
    await this.callGetNumbering();
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // TODO 性別ID取得処理？
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    async callGetNumbering() {
      // 採番取API
      const restResourceService = new ApiClient();
      this.num = await restResourceService.getNumbering('user');
      const number = (('00000' + this.num).slice(-5));
      this.detail.loginId = 'EP2-' + number;
    },
    async callGetLoginIdcheck() {
      // 採番取API
      const restResourceService = new ApiClient();
      this.idCheckFlg = await restResourceService.getLoginIdcheck(this.detail.loginId);
    },
    async callUpdateNumbering() {
      // 採番更新API
      const restResourceService = new ApiClient();
      await restResourceService.updateNumbering('user');
    },
    // 郵便番号を元に住所取得
    getAddress() {
      const restResourceService = new ApiClient();
      restResourceService.getAddress(this.detail.postalCode)
        .then((res) => {
          if(res === 404){
            this.postalHasError = false;
            this.detail.prefecture = '';
            this.detail.city = '';
            this.detail.town = '';
          } else{
          this.postalHasError = true;
          this.detail.prefecture = res.pref;
          this.detail.city = res.city;
          this.detail.town = res.town;
          }
        },
        );
    },
    // 登録ボタン押下時 登録処理
    async confirm(detail, ccus) {
      // ボタン非活性化
      this.startProcessing();
      // 採番重複チェック
      try {
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        // 採番重複チェック
        await this.callGetLoginIdcheck();
        // ログインIDが重複していた場合
        if (this.idCheckFlg) {
          await this.callGetNumbering();
          return;
        }
      } catch (error) {
        this.errorMessage = error.message;
        this.postErrorFlg = true;
      } finally {
        // ローディング非表示
        this.postLodingFlg = false;
      }
      // ====================入力項目空白削除====================
      detail.lastName = detail.lastName.trim();
      detail.firstName = detail.firstName.trim();
      detail.lastNameKana = detail.lastNameKana.trim();
      detail.firstNameKana = detail.firstNameKana.trim();
      if (detail.town) {
        detail.town = detail.town.trim();
      }
      if (detail.otherAddress) {
        detail.otherAddress = detail.otherAddress.trim();
      }
      if(detail.prefecture === undefined)detail.prefecture = '';
      if(detail.city === undefined)detail.city = '';
      if(detail.town === undefined)detail.town = '';
      // ====================入力チェック====================
      // 入力チェックメッセージ初期化
      this.validationErrMsg = [];
      // 郵便番号と住所の妥当性チェック(郵便番号,都道府県,市区町村)
      if (detail.postalCode) {
        if (!detail.prefecture || !detail.city) {
          this.validationErrMsg.push('住所を登録する場合、都道府県、市区町村、町・番地を入力して下さい');
        }
        if (detail.prefecture && detail.city && !detail.town) {
          this.validationErrMsg.push('住所を登録する場合、町・番地を入力して下さい');
        }
      }
      if (detail.nationality === 1) {
        detail.workerName = detail.lastName + detail.firstName;
      } else if (detail.nationality === 2) {
        detail.workerName = detail.firstName + detail.lastName;
      } else {
        this.validationErrMsg.push('国籍選択が不正です');
      }
      if (this.validationErrMsg.length !== 0) {
        return;
      }
      // ====================API呼出処理====================
      try {
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        // 技能者新規登録API呼出
        const body = [{
          ccusWorkerId: detail.ccusWorkerId,
          ccusSecurityCode: detail.ccusSecurityCode,
          workerName: detail.workerName,
          lastName: detail.lastName,
          firstName: detail.firstName,
          lastNameKana: detail.lastNameKana,
          firstNameKana: detail.firstNameKana,
          birthdate: detail.birthdate,
          genderId: detail.gender,
          loginId: detail.loginId,
          email: detail.email,
          nationality: detail.nationality,
          postalCode: detail.postalCode,
          prefecture: detail.prefecture,
          city: detail.city,
          town: detail.town,
          otherAddress: detail.otherAddress,
          tel: detail.tel,
          companyId: this.companyId,
          branchId: this.branchId,
        }];
        const restResourceService = new ApiClient();
        // 技能者新規登録API呼出
        await restResourceService.postWorkers(body);
        // cognitoへ技能者権限アカウントを新規登録
        await this.$cognito.signUp(detail.loginId, detail.email, detail.password, '7');
        await this.$cognito.setUserPassword(detail.loginId, detail.email, detail.password);
        console.log("====detail======", detail)
        const  mailBody = {
          loginId: detail['loginId'],
          email: detail.email,
          newEmail: detail.email,
          role: 'worker',
        };
        console.log("=====mailBody=====",mailBody);
        if (detail.email != '') {
          // cognito メール確認処理
          await restResourceService.patchAccountEmail(mailBody);
          // メール送信API呼出
          // TODO URL修正
          // メールに使用するTemplateData
          const templateData = {
            loginid: detail.loginId,
            password: detail.password,    
            // 開発環境
            // url: 'http://ep-manager-front-dev-s3-front-bucket.s3-website-ap-northeast-1.amazonaws.com'
            // アート検証環境
            // url: 'http://ep-manager-front-dev2-s3-front-bucket.s3-website-ap-northeast-1.amazonaws.com'
            // 本番環境
            url: 'https://ep-manager.com'
          };
          await restResourceService.workerSignUpMail(detail.email, templateData);
        }
        ccus.value = JSON.stringify(detail, null, 2);

        // CCUSより情報を取得？ 無ければNullを渡す
        const ccusBody = [{
          version: ccus.version,
          ccusId: detail.ccusWorkerId,
          value: ccus.value,
          modified: ccus.modified,
        }];
        // 使用しないかもしれない
        // await restResourceService.postCcusWorker(ccusBody);

        // await this.callUpdateNumbering();
        this.screenTransition();
      } catch (error) {
        this.errorMessage = error.message;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 画面遷移
    screenTransition() {
      history.back();
    },
    isPostDisabled(item,isError){
      return common.isPostalValidate(item,isError,2)
    },
    // チャタリング防止
    startProcessing() {
      this.processing = true;
    },
    endProcessing() {
      this.processing = false;
    },
    isProcessing() {
      return this.processing;
    },
  },
  filters: {
    filterZip(d) {
      const buf = ('0000000' + d).slice(-7);
      return buf;
      // return isNaN(buf) ? '1000000' : buf;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius: 10px;
  -ms-word-break: normal;
  word-break: normal;
}
</style>
